The identifier for the associated hirer. This corresponds to the `HiringOrganization.id` field in the GraphQL schema, and is only available on signed webhook subscriptions.
